import { useEffect, useState } from "react";
import { C } from "@/lib/brand";

let pushFn = null;
export function toast(message, type = "info") {
  if (pushFn) pushFn({ id: Date.now() + Math.random(), message, type });
}

export default function ToastHost() {
  const [toasts, setToasts] = useState([]);
  useEffect(() => {
    pushFn = (t) => {
      setToasts((prev) => [...prev, t]);
      setTimeout(() => setToasts((prev) => prev.filter((x) => x.id !== t.id)), 4500);
    };
    return () => {
      pushFn = null;
    };
  }, []);
  return (
    <div
      data-testid="toast-host"
      style={{
        position: "fixed",
        bottom: 80,
        right: 16,
        zIndex: 100,
        display: "flex",
        flexDirection: "column",
        gap: 10,
        maxWidth: "calc(100vw - 32px)",
      }}
    >
      {toasts.map((t) => {
        const bg = t.type === "error" ? C.coral : t.type === "success" ? C.sageDeep : C.ink;
        return (
          <div
            key={t.id}
            data-testid={`toast-${t.type}`}
            style={{
              background: bg,
              color: C.cream,
              padding: "14px 18px",
              fontSize: 13,
              fontWeight: 600,
              letterSpacing: "0.02em",
              minWidth: 240,
              boxShadow: "0 8px 24px rgba(0,0,0,0.18)",
            }}
          >
            {t.message}
          </div>
        );
      })}
    </div>
  );
}
